/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import Total4WMarketProductsPage from 'src/pages/ReportsPages/ReportsBoard/4wPages/Total4WMarketProductsPage'
import boardReportsService from 'src/services/boardReportsService'

const Total4WMarketProductsContainer = () => {
  const [total7PC, setTotal7PC] = useState([])
  const [total9PC, setTotal9PC] = useState([])
  const [gTotal8PC, setTotal8PC] = useState([])
  const [gTotal7APC, setGTotal7APC] = useState([])
  const [gTotal7BPC, setGTotal7BPC] = useState([])

  const [total7PCC, setTotal7PCC] = useState([])
  const [total9PCC, setTotal9PCC] = useState([])
  const [gTotal8PCC, setTotal8PCC] = useState([])
  const [gTotal7APCC, setGTotal7APCC] = useState([])
  const [gTotal7BPCC, setGTotal7BPCC] = useState([])

  const [total7PK, setTotal7PK] = useState([])
  const [total9PK, setTotal9PK] = useState([])
  const [gTotal8PK, setTotal8PK] = useState([])
  const [gTotal7APK, setGTotal7APK] = useState([])
  const [gTotal7BPK, setGTotal7BPK] = useState([])

  const [total1MPK, setTotal1MPK] = useState([])
  const [total9MPK, setTotal9MPK] = useState([])
  const [gTotal2MPK, setGTotal2MPK] = useState([])
  const [gTotal7AMPK, setGTotal7AMPK] = useState([])
  const [gTotal7BMPK, setGTotal7BMPK] = useState([])

  const [total1VAN, setTotal1VAN] = useState([])
  const [total9VAN, setTotal9VAN] = useState([])
  const [gTotal2VAN, setGTotal2VAN] = useState([])
  const [gTotal7AVAN, setGTotal7AVAN] = useState([])
  const [gTotal7BVAN, setGTotal7BVAN] = useState([])

  const [total1SVAN, setTotal7SVAN] = useState([])
  const [total9SVAN, setTotal9SVAN] = useState([])
  const [gTotal2SVAN, setTotal8SVAN] = useState([])
  const [gTotal7ASVAN, setGTotal7ASVAN] = useState([])
  const [gTotal7BSVAN, setGTotal7BSVAN] = useState([])

  const [total7ULIV, setTotal7ULIV] = useState([])
  const [total9ULIV, setTotal9ULIV] = useState([])
  const [gTotal8ULIV, setTotal8ULIV] = useState([])
  const [gTotal7AULIV, setGTotal7AULIV] = useState([])
  const [gTotal7BULIV, setGTotal7BULIV] = useState([])

  const [total7LIV, setTotal7LIV] = useState([])
  const [total9LIV, setTotal9LIV] = useState([])
  const [gTotal8LIV, setTotal8LIV] = useState([])
  const [gTotal7ALIV, setGTotal7ALIV] = useState([])
  const [gTotal7BLIV, setGTotal7BLIV] = useState([])

  const [total7HEV, setTotal7HEV] = useState([])
  const [total9HEV, setTotal9HEV] = useState([])
  const [gTotal8HEV, setTotal8HEV] = useState([])
  const [gTotal7AHEV, setGTotal7AHEV] = useState([])
  const [gTotal7BHEV, setGTotal7BHEV] = useState([])

  const [total7TAX, setTotal7TAX] = useState([])
  const [total9TAX, setTotal9TAX] = useState([])
  const [gTotal8TAX, setTotal8TAX] = useState([])
  const [gTotal7ATAX, setGTotal7ATAX] = useState([])
  const [gTotal7BTAX, setGTotal7BTAX] = useState([])

  const [total7TAXSUV, setTotal7TAXSUV] = useState([])
  const [total9TAXSUV, setTotal9TAXSUV] = useState([])
  const [gTotal8TAXSUV, setTotal8TAXSUV] = useState([])
  const [gTotal7ATAXSUV, setGTotal7ATAXSUV] = useState([])
  const [gTotal7BTAXSUV, setGTotal7BTAXSUV] = useState([])

  const [total7MICBUS, setTotal7MICBUS] = useState([])
  const [total9MICBUS, setTotal9MICBUS] = useState([])
  const [gTotal8MICBUS, setTotal8MICBUS] = useState([])
  const [gTotal7AMICBUS, setGTotal7AMICBUS] = useState([])
  const [gTotal7BMICBUS, setGTotal7BMICBUS] = useState([])

  const [total7BUS, setTotal7BUS] = useState([])
  const [total9BUS, setTotal9BUS] = useState([])
  const [gTotal8BUS, setTotal8BUS] = useState([])
  const [gTotal7ABUS, setGTotal7ABUS] = useState([])
  const [gTotal7BBUS, setGTotal7BBUS] = useState([])

  const [total7BUSETA, setTotal7BUSETA] = useState([])
  const [total9BUSETA, setTotal9BUSETA] = useState([])
  const [gTotal8BUSETA, setTotal8BUSETA] = useState([])
  const [gTotal7ABUSETA, setGTotal7ABUSETA] = useState([])
  const [gTotal7BBUSETA, setGTotal7BBUSETA] = useState([])

  const [selectedDate, setSelectedDate] = useState(new Date())

  const reloadTotalMarkersPersonalFourTrack = async () => {
    const [total7PC, total9PC, gTotal8PC, gTotal7APC, gTotal7BPC] = await Promise.all([
      boardReportsService.getTotalMarket4W(
        '7',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=CUADRICICLO'
      ),
      boardReportsService.getTotalMarket4W(
        '9',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=CUADRICICLO'
      ),
      boardReportsService.getGTotalMarket4W(
        '8',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=CUADRICICLO'
      ),
      boardReportsService.getGTotalMarket4W(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=CUADRICICLO&limite=6'
      ),
      boardReportsService.getGTotalMarket4W(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=CUADRICICLO&limite=6'
      ),
    ])
    setTotal7PC(total7PC)
    setTotal9PC(total9PC)
    setTotal8PC(gTotal8PC)
    setGTotal7APC(gTotal7APC)
    setGTotal7BPC(gTotal7BPC)
  }

  const reloadTotalMarkersPersonalCar = async () => {
    const [total7PCC, total9PCC, gTotal8PCC, gTotal7APCC, gTotal7BPCC] = await Promise.all([
      boardReportsService.getTotalMarket4W(
        '7',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=AUTOMOVIL'
      ),
      boardReportsService.getTotalMarket4W(
        '9',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=AUTOMOVIL'
      ),
      boardReportsService.getGTotalMarket4W(
        '8',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=AUTOMOVIL'
      ),
      boardReportsService.getGTotalMarket4W(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=AUTOMOVIL&limite=6'
      ),
      boardReportsService.getGTotalMarket4W(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=AUTOMOVIL&limite=6'
      ),
    ])
    setTotal7PCC(total7PCC)
    setTotal9PCC(total9PCC)
    setTotal8PCC(gTotal8PCC)
    setGTotal7APCC(gTotal7APCC)
    setGTotal7BPCC(gTotal7BPCC)
  }

  const reloadTotalMarkersPersonalPickUp = async () => {
    const [total7PK, total9PK, gTotal8PK, gTotal7APK, gTotal7BPK] = await Promise.all([
      boardReportsService.getTotalMarket4W('7', selectedDate.getFullYear(), 'subcategoria=PERSONALES&segmento=PICK UP'),
      boardReportsService.getTotalMarket4W('9', selectedDate.getFullYear(), 'subcategoria=PERSONALES&segmento=PICK UP'),
      boardReportsService.getGTotalMarket4W(
        '8',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=PICK UP'
      ),
      boardReportsService.getGTotalMarket4W(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=PICK UP&limite=6'
      ),
      boardReportsService.getGTotalMarket4W(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=PERSONALES&segmento=PICK UP&limite=6'
      ),
    ])
    setTotal7PK(total7PK)
    setTotal9PK(total9PK)
    setTotal8PK(gTotal8PK)
    setGTotal7APK(gTotal7APK)
    setGTotal7BPK(gTotal7BPK)
  }

  const reloadTotalMarkersPickUp = async () => {
    const [total1MPK, total9MPK, gTotal2MPK, gTotal7AMPK, gTotal7BMPK] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct('1', selectedDate.getFullYear()),
      boardReportsService.getTotalMarket4WProduct('2', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket4WProduct('2', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket4WProduct('3a', selectedDate.getFullYear(), 'limite=10'),
      boardReportsService.getGTotalMarket4WProduct('3b', selectedDate.getFullYear(), 'limite=10'),
    ])
    setTotal1MPK(total1MPK || [])
    setTotal9MPK(total9MPK || [])
    setGTotal2MPK(gTotal2MPK || [])
    setGTotal7AMPK(gTotal7AMPK || [])
    setGTotal7BMPK(gTotal7BMPK || [])
  }

  const reloadTotalMarkerVAN = async () => {
    const [total1VAN, total9VAN, gTotal2VAN, gTotal7AVAN, gTotal7BVAN] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct('3', selectedDate.getFullYear()),
      boardReportsService.getTotalMarket4WProduct('4', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket4WProduct('4', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket4WProduct('5a', selectedDate.getFullYear(), 'limite=10'),
      boardReportsService.getGTotalMarket4WProduct('5b', selectedDate.getFullYear(), 'limite=10'),
    ])
    setTotal1VAN(total1VAN || [])
    setTotal9VAN(total9VAN || [])
    setGTotal2VAN(gTotal2VAN || [])
    setGTotal7AVAN(gTotal7AVAN || [])
    setGTotal7BVAN(gTotal7BVAN || [])
  }

  const reloadTotalMarkersCommercialSubsegmentVAN = async () => {
    const [total7SVAN, total9SVAN, gTotal8SVAN, gTotal7ASVAN, gTotal7BSVAN] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct(
        '5',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=VAN'
      ),
      boardReportsService.getTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=VAN'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=VAN'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '5a',
        selectedDate.getFullYear(),
        'limite=10'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '5b',
        selectedDate.getFullYear(),
        'limite=10'
      ),
    ])
    setTotal7SVAN(total7SVAN)
    setTotal9SVAN(total9SVAN)
    setTotal8SVAN(gTotal8SVAN)
    setGTotal7ASVAN(gTotal7ASVAN)
    setGTotal7BSVAN(gTotal7BSVAN)
  }

  const reloadTotalMarkersCommercialSubsegmentUltraULIV = async () => {
    const [total7ULIV, total9ULIV, gTotal8ULIV, gTotal7AULIV, gTotal7BULIV] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct(
        '5',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=ULTRA LIVIANO'
      ),
      boardReportsService.getTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=ULTRA LIVIANO'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=ULTRA LIVIANO'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=ULTRA LIVIANO&limite=10'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=ULTRA LIVIANO&limite=10'
      ),
    ])
    setTotal7ULIV(total7ULIV)
    setTotal9ULIV(total9ULIV)
    setTotal8ULIV(gTotal8ULIV)
    setGTotal7AULIV(gTotal7AULIV)
    setGTotal7BULIV(gTotal7BULIV)
  }

  const reloadTotalMarkersCommercialSubsegmentULIV = async () => {
    const [total7LIV, total9LIV, gTotal8LIV, gTotal7ALIV, gTotal7BLIV] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct(
        '5',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=LIVIANO'
      ),
      boardReportsService.getTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=LIVIANO'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=LIVIANO'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=LIVIANO&limite=10'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=LIVIANO&limite=10'
      ),
    ])
    setTotal7LIV(total7LIV)
    setTotal9LIV(total9LIV)
    setTotal8LIV(gTotal8LIV)
    setGTotal7ALIV(gTotal7ALIV)
    setGTotal7BLIV(gTotal7BLIV)
  }

  const reloadTotalMarkersCommercialSubsegmentPESADO = async () => {
    const [total7HEV, total9HEV, gTotal8HEV, gTotal7AHEV, gTotal7BHEV] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct(
        '5',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=PESADO'
      ),
      boardReportsService.getTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=PESADO'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=PESADO'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=PESADO&limite=10'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=CARGA&subsegmento=PESADO&limite=10'
      ),
    ])
    setTotal7HEV(total7HEV)
    setTotal9HEV(total9HEV)
    setTotal8HEV(gTotal8HEV)
    setGTotal7AHEV(gTotal7AHEV)
    setGTotal7BHEV(gTotal7BHEV)
  }

  const reloadTotalMarkersPersonalSubsegmentTAXI = async () => {
    const [total7TAX, total9TAX, gTotal8TAX, gTotal7ATAX, gTotal7BTAX] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct(
        '5',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI AUTOMOVIL'
      ),
      boardReportsService.getTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI AUTOMOVIL'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI AUTOMOVIL'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI AUTOMOVIL&limite=10'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI AUTOMOVIL&limite=10'
      ),
    ])
    setTotal7TAX(total7TAX)
    setTotal9TAX(total9TAX)
    setTotal8TAX(gTotal8TAX)
    setGTotal7ATAX(gTotal7ATAX)
    setGTotal7BTAX(gTotal7BTAX)
  }

  const reloadTotalMarkersPersonalSubsegmentTAXISUV = async () => {
    const [total7TAXSUV, total9TAXSUV, gTotal8TAXSUV, gTotal7ATAXSUV, gTotal7BTAXSUV] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct(
        '5',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI SUV'
      ),
      boardReportsService.getTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI SUV'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI SUV'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI SUV&limite=10'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=TAXI SUV&limite=10'
      ),
    ])
    setTotal7TAXSUV(total7TAXSUV)
    setTotal9TAXSUV(total9TAXSUV)
    setTotal8TAXSUV(gTotal8TAXSUV)
    setGTotal7ATAXSUV(gTotal7ATAXSUV)
    setGTotal7BTAXSUV(gTotal7BTAXSUV)
  }

  const reloadTotalMarkersPersonalSubsegmentMICROBUS = async () => {
    const [total7MICBUS, total9MICBUS, gTotal8MICBUS, gTotal7AMICBUS, gTotal7BMICBUS] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct(
        '5',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=MICROBUS'
      ),
      boardReportsService.getTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=MICROBUS'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=MICROBUS'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=MICROBUS&limite=10'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=MICROBUS&limite=10'
      ),
    ])
    setTotal7MICBUS(total7MICBUS)
    setTotal9MICBUS(total9MICBUS)
    setTotal8MICBUS(gTotal8MICBUS)
    setGTotal7AMICBUS(gTotal7AMICBUS)
    setGTotal7BMICBUS(gTotal7BMICBUS)
  }

  const reloadTotalMarkersPersonalSubsegmentBUS = async () => {
    const [total7BUS, total9BUS, gTotal8BUS, gTotal7ABUS, gTotal7BBUS] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct(
        '5',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUS'
      ),
      boardReportsService.getTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUS'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUS'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUS&limite=10'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUS&limite=10'
      ),
    ])
    setTotal7BUS(total7BUS)
    setTotal9BUS(total9BUS)
    setTotal8BUS(gTotal8BUS)
    setGTotal7ABUS(gTotal7ABUS)
    setGTotal7BBUS(gTotal7BBUS)
  }

  const reloadTotalMarkersPersonalSubsegmentBUSETA = async () => {
    const [total7BUSETA, total9BUSETA, gTotal8BUSETA, gTotal7ABUSETA, gTotal7BBUSETA] = await Promise.all([
      boardReportsService.getTotalMarket4WProduct(
        '5',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUSETA'
      ),
      boardReportsService.getTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUSETA'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUSETA'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUSETA&limite=10'
      ),
      boardReportsService.getGTotalMarket4WProduct(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS&subsegmento=BUSETA&limite=10'
      ),
    ])
    setTotal7BUSETA(total7BUSETA)
    setTotal9BUSETA(total9BUSETA)
    setTotal8BUSETA(gTotal8BUSETA)
    setGTotal7ABUSETA(gTotal7ABUSETA)
    setGTotal7BBUSETA(gTotal7BBUSETA)
  }

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadTotalMarkersPersonalFourTrack()
    reloadTotalMarkersPersonalCar()
    reloadTotalMarkersPersonalPickUp()
    reloadTotalMarkersPickUp()
    reloadTotalMarkerVAN()
    reloadTotalMarkersCommercialSubsegmentVAN()
    reloadTotalMarkersCommercialSubsegmentUltraULIV()
    reloadTotalMarkersCommercialSubsegmentULIV()
    reloadTotalMarkersCommercialSubsegmentPESADO()
    reloadTotalMarkersPersonalSubsegmentTAXI()
    reloadTotalMarkersPersonalSubsegmentTAXISUV()
    reloadTotalMarkersPersonalSubsegmentMICROBUS()
    reloadTotalMarkersPersonalSubsegmentBUS()
    reloadTotalMarkersPersonalSubsegmentBUSETA()
  }, [selectedDate])

  return (
    <Total4WMarketProductsPage
      total7BUSETA={total7BUSETA}
      total9BUSETA={total9BUSETA}
      gTotal8BUSETA={gTotal8BUSETA}
      gTotal7ABUSETA={gTotal7ABUSETA}
      gTotal7BBUSETA={gTotal7BBUSETA}
      total7BUS={total7BUS}
      total9BUS={total9BUS}
      gTotal8BUS={gTotal8BUS}
      gTotal7ABUS={gTotal7ABUS}
      gTotal7BBUS={gTotal7BBUS}
      total7MICBUS={total7MICBUS}
      total9MICBUS={total9MICBUS}
      gTotal8MICBUS={gTotal8MICBUS}
      gTotal7AMICBUS={gTotal7AMICBUS}
      gTotal7BMICBUS={gTotal7BMICBUS}
      total7TAXSUV={total7TAXSUV}
      total9TAXSUV={total9TAXSUV}
      gTotal8TAXSUV={gTotal8TAXSUV}
      gTotal7ATAXSUV={gTotal7ATAXSUV}
      gTotal7BTAXSUV={gTotal7BTAXSUV}
      total7TAX={total7TAX}
      total9TAX={total9TAX}
      gTotal8TAX={gTotal8TAX}
      gTotal7ATAX={gTotal7ATAX}
      gTotal7BTAX={gTotal7BTAX}
      total7HEV={total7HEV}
      total9HEV={total9HEV}
      gTotal8HEV={gTotal8HEV}
      gTotal7AHEV={gTotal7AHEV}
      gTotal7BHEV={gTotal7BHEV}
      total7LIV={total7LIV}
      total9LIV={total9LIV}
      gTotal8LIV={gTotal8LIV}
      gTotal7ALIV={gTotal7ALIV}
      gTotal7BLIV={gTotal7BLIV}
      total7ULIV={total7ULIV}
      total9ULIV={total9ULIV}
      gTotal8ULIV={gTotal8ULIV}
      gTotal7AULIV={gTotal7AULIV}
      gTotal7BULIV={gTotal7BULIV}
      total7SVAN={total1SVAN}
      total9SVAN={total9SVAN}
      gTotal2SVAN={gTotal2SVAN}
      gTotal7ASVAN={gTotal7ASVAN}
      gTotal7BSVAN={gTotal7BSVAN}
      total1VAN={total1VAN}
      total9VAN={total9VAN}
      gTotal2VAN={gTotal2VAN}
      gTotal7AVAN={gTotal7AVAN}
      gTotal7BVAN={gTotal7BVAN}
      total7PC={total7PC}
      total9PC={total9PC}
      gTotal7APC={gTotal7APC}
      gTotal7BPC={gTotal7BPC}
      gTotal8PC={gTotal8PC}
      total7PCC={total7PCC}
      total9PCC={total9PCC}
      gTotal7APCC={gTotal7APCC}
      gTotal7BPCC={gTotal7BPCC}
      gTotal8PCC={gTotal8PCC}
      total7PK={total7PK}
      total9PK={total9PK}
      gTotal7APK={gTotal7APK}
      gTotal7BPK={gTotal7BPK}
      gTotal8PK={gTotal8PK}
      total1MPK={total1MPK}
      total9MPK={total9MPK}
      gTotal7AMPK={gTotal7AMPK}
      gTotal7BMPK={gTotal7BMPK}
      gTotal2MPK={gTotal2MPK}
      selectedDate={selectedDate}
      handleDateChange={handleDateChange}
    />
  )
}

export default Total4WMarketProductsContainer
